module.exports = __webpack_public_path__ + "img/no-data1.882d0027.png";